import { SignoffConfigForStep } from '.';
import { makeRequest, CommonRequestOptions } from '../makeRequest';

export async function deleteSignoffConfigForStep(
   stepId: number,
   common: CommonRequestOptions = {}
): Promise<SignoffConfigForStep> {
   return makeRequest('delete', `/signoffs/${stepId}/signoff`, {
      ...common,
      body: {},
   });
}
